import { useMemo, type ReactNode } from "react";
import { useEditorStore } from "../../../state/editor/useEditor";
import { basicEngineFor } from "../basic/applyEngine";
import { EditScope } from "./rows";

/**
 * Put every Compact control inside `children` into the studio's Undo history,
 * labelled "<title> · <row>". InspectorSection sets this up itself; the
 * Advanced left panels (Background, Ground, Lighting…) use this wrapper.
 */
export function RecordingScope({ title, children }: { title: string; children: ReactNode }) {
  const store = useEditorStore();
  const value = useMemo(
    () => ({
      section: title,
      record: (e: Parameters<ReturnType<typeof basicEngineFor>["recordExternal"]>[0]) => basicEngineFor(store).recordExternal(e),
    }),
    [title, store],
  );
  return <EditScope.Provider value={value}>{children}</EditScope.Provider>;
}
